import { formatNumber } from "@angular/common";

export const separatorMil = (locale: string) => formatNumber(1000, locale, "1.2-2").substring(1, 2);

export const separatorDec = (locale: string) => formatNumber(Math.PI, locale, "1.2-2").substring(1, 2);
